import axiosConfig from "./axiosConfig";

export interface CreateSiteReadingsTablesResponse {
  site_id: string;
  tables_created: string[];
}

const postCreateSiteReadingsTables = async (
  authToken: string,
  siteId: string
): Promise<CreateSiteReadingsTablesResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/ingestion/readings_tables`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postCreateSiteReadingsTables;
